<template>
  <oie-my-pages-template :title="title" :text="t('myUsersEditUserSubTitle2')" :with-go-back="true">
    <oie-add-edit-user-form @cancel="goToSubPage(navigationOptions.oieMyUsers)"></oie-add-edit-user-form>
  </oie-my-pages-template>
</template>

<script>
import myPages from '@/mixins/my-pages'
import { mapGetters } from 'vuex'

export default {
  mixins: [myPages],
  computed: {
    ...mapGetters('myUsers', ['currentUser']),
    title() {
      return this.currentUser ? `${this.currentUser.firstName} ${this.currentUser.lastName}` : this.t('editUser')
    }
  }

}
</script>
